import { createContext } from 'react';

import { ContractFileProcessingStatus } from 'src/services/api/contractsApi';

export interface ContractFile {
  fileKey: string;
  pageFileKeys: string[];
  identityId: string;
  // Processing status of the page-to-image conversion. Templates loaded for
  // edit (existing records) leave this undefined since their pages are
  // already in S3.
  processingStatus?: ContractFileProcessingStatus;
}

export interface ContractBuilderContext {
  placeholderElement: HTMLButtonElement | null;
  contractPdfInfo: ContractFile;
  isOneOffContract: boolean;
  pageScalerFactor: number;
  initialRecipient: { clientId: string; companyId: string } | null;
  setPlaceholderElement: (element: HTMLButtonElement | null) => void;
  setContractPdfInfo: (info: ContractFile) => void;
  setIsOneOffContract: (value: boolean) => void;
  setPageScalerFactor: (value: number) => void;
}

const initialContextValue: ContractBuilderContext = {
  placeholderElement: null,
  contractPdfInfo: {
    fileKey: '',
    pageFileKeys: [],
    identityId: '',
  },
  pageScalerFactor: 1,
  isOneOffContract: false,
  initialRecipient: null,
  setPlaceholderElement: () => null,
  setContractPdfInfo: () => null,
  setIsOneOffContract: () => null,
  setPageScalerFactor: () => null,
};

export const ContractBuilderContext = createContext(initialContextValue);
